import { createFileRoute } from "@tanstack/react-router";

import { Feedback } from "@/features/my/feedback";

export const Route = createFileRoute("/(member)/(protected)/my/feedback/")({
  component: Feedback,
});
